export default {
  state: {
    active: false,
  },
  mutations: {
    updateLoading(state, active) {
      state.active = active;
    },
  },
  actions: {
    updateLoading(context, active) {
      context.commit("updateLoading", active);
    },
  },
};
